@if (action) {
  <div class="compliance-review-body">
    <!-- Summary: license status + operating states -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <dl class="trade-summary">
            <div class="trade-summary__row">
              <dt>All trade licenses valid?</dt>
              <dd>
                <span class="fw-semibold chip-host" appStatusStyleChanges>
                  {{ areAllLicensesValid() ? 'PASSED' : 'REVIEWING' }}
                </span>
              </dd>
            </div>
            <div class="trade-summary__row">
              <dt>Operating States</dt>
              <dd>{{ vendorCompanyTradeStates || '—' }}</dd>
            </div>
          </dl>
        </app-display-card>
      </div>
    </div>

    <!-- Trades section -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card [innerPanel]="true">
          <div class="trade-section-head">
            <h3 class="mb-0">Trades</h3>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="chooseTrades()"
            >
              <i class="bi bi-plus-lg me-1"></i>
              Choose trades
            </button>
          </div>
          <div class="trade-grid">
            <app-vendor-trades-grid
              [gridName]="'AdminVendorTradesGrid'"
              [ColumnIdToColumnActions]="TradesColumnIdToColumnActions"
              [TooltipMap]="TradesTooltipMap"
              [suppliedQueryData]="TradesSuppliedGridQuery"
              (actionEvent)="tradeActionEvent($event)"
              [(reloadGridData)]="reloadVendorTradesGrid"
            ></app-vendor-trades-grid>
          </div>
        </app-display-card>
      </div>
    </div>

    <!-- Trade licenses section -->
    @if (SuppliedPrimaryTradeLicenseQueryData) {
      <div class="row">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="trade-section-head">
              <h3 class="mb-0">Trade licenses</h3>
            </div>
            <div class="trade-grid">
              <app-primary-trade-license-requirements-grid
                [gridName]="'AdminTradeLicenseRequirementsGrid'"
                [TooltipMap]="LicenseTooltipMap"
                [ColumnIdToColumnActions]="LicenseColumnIdToColumnActions"
                [suppliedQueryData]="SuppliedPrimaryTradeLicenseQueryData"
                [suppressFieldDotNotation]="true"
                (actionEvent)="licenseActionEvent($event)"
                [getCalculatedColumnActions]="calculateLicenseGridActions"
                [(reloadGridData)]="reloadLicensedGrid"
                [preventDistinctCount]="true"
                [getRowId]="getLicensesRowId"
              >
              </app-primary-trade-license-requirements-grid>
            </div>
          </app-display-card>
        </div>
      </div>
    }
  </div>
}
